import React, { useContext } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { APIContext } from "../../Contexts/APIContext";
import GetChallengeNoteViewModel from "../Shared/ViewModels/GetChallengeNoteViewModel";

interface ITeamLeaderChallengePageButtonsProps {
    noteSubmitHandler: (isEscalated: boolean) => void;
    notesViewModel: GetChallengeNoteViewModel[]
}

export default function TeamLeaderChallengePageButtons({ noteSubmitHandler, notesViewModel }: ITeamLeaderChallengePageButtonsProps) {
    const { loading } = useContext(APIContext)

    return (
        <Grid>
            <Button
                variant="contained"
                color="primary"
                disabled={
                    loading
                    ||
                    notesViewModel.some(x =>
                        x.type === 'Escalation'
                        && x.state !== 'Rejected'
                        && x.state !== 'Resolved')}
                onClick={() => noteSubmitHandler(true)}>
                Escalate to QA
            </Button>
        </Grid>
    )
}